import { APIFetchOverview, APIFetchOverviewDateHourly } from "../api/overview.ts";
import {
  setKpiData,
  setCompareData,
  setAllTrendData,
  setByPeriods,
  setKpiDataHourly,
  setCompareDataHourly,
  setAllTrendDataHourly,
  setByPeriodsHourly,

  
} from "../core/redux/overview/overview.action.jsx";
import converter from "../helpers/fidaToOldConverter.ts";
import store from "../core/redux/store.jsx";

export async function fetchOverview({
  startDate,
  endDate,
  compareStartDate,
  compareEndDate,
  storeCodes,
  days,
  kpis,
  groupByMetricKey,
  comparisonYKPIMetricKey,
  trackLatest,
}) {
  let res = {};
  if (trackLatest) {
    //   commit('setTracker', trackLatest);
  }
  if (storeCodes != "" && startDate != null) {
    res = await APIFetchOverview({
      startDate,
      endDate,
      compareStartDate,
      compareEndDate,
      storeCodes,
      days,
      kpis: kpis ? kpis : "all",
      groupByMetricKey,
      comparisonYKPIMetricKey,
    });
    console.log("Call for Dashboard");
    // if(trackLatest) {
    // //   if(state.callTracker[trackLatest.callerId] !== trackLatest.value) {
    // //     return false;
    // //   }
    // }
    let kpisData = res?.dashboard?.data?.length
      ? res.dashboard.data[0].kpis
      : {};
    console.log('kpisData kpisData',kpisData);
    let kpisbyPeriod = res?.byPeriod?.data?.length
      ? res.byPeriod.data[0].kpis
      : {};
    const distributionResult =
      converter.convertApiResponseDistribution(kpisbyPeriod);
    store.dispatch(setKpiData(JSON.parse(JSON.stringify(kpisData))));
    store.dispatch(setCompareData(res?.dashboard?.compareData?res.dashboard.compareData:null));
    store.dispatch(setAllTrendData(res?.dashboard?.allTrends?res.dashboard.allTrends:null));
    //
    store.dispatch(setByPeriods(distributionResult.data));

    return res;
  } else return [];
}



export async function fetchOverviewHourly({
  startDate,
  endDate,
  compareStartDate,
  compareEndDate,
  storeCodes,
  days,
  frequency,
  kpis,
  groupByMetricKey,
  comparisonYKPIMetricKey,
  trackLatest,
}) {
  let res = {};
  if (trackLatest) {
    //   commit('setTracker', trackLatest);
  }
  if (storeCodes != "" && startDate != null) {
    res = await APIFetchOverviewDateHourly({
      startDate,
      endDate,
      compareStartDate,
      compareEndDate,
      storeCodes,
      days,
      frequency,
      kpis: kpis ? kpis : "all",
      groupByMetricKey,
      comparisonYKPIMetricKey,
    });
    console.log("Call for Dashboard");
    // if(trackLatest) {
    // //   if(state.callTracker[trackLatest.callerId] !== trackLatest.value) {
    // //     return false;
    // //   }
    // }
    let kpisData = res?.dashboard?.data?.length
      ? res.dashboard.data[0].kpis
      : {};

    let kpisbyPeriod = res?.byPeriod?.data?.length
      ? res.byPeriod.data[0].kpis
      : {};
    const distributionResult =
      converter.convertApiResponseDistribution(kpisbyPeriod);
    store.dispatch(setKpiDataHourly(JSON.parse(JSON.stringify(kpisData))));
    store.dispatch(setCompareDataHourly(res?.dashboard?.compareData?res.dashboard.compareData:null));
    store.dispatch(setAllTrendDataHourly(res?.dashboard?.allTrends?res.dashboard.allTrends:null));
    //
    store.dispatch(setByPeriodsHourly(distributionResult.data));

    return res;
  } else return [];
}

const kpisTitle = {
  sls: "Sales",
  trf: "Traffic",
  cn: "Conversion",
  trn: "Transaction",
  is: "Units Sold",
  pb: "Passers By",
  sh: "Staff Hours",
  ap: "Average Purchase",
  aip: "Average Item Price",
  upt: "Units Per Transaction",
  rov: "Return on Visit",
  spt: "Sales Per Sqm",
  tpt: "Traffic Per Sqm",
  sl: "Staff Level",
  se: "Staff Efficiency",
  cr: "Capture Rate",
  cs: "Closing Strength",
  tra: "Target Achievement Rate",
};
export default kpisTitle;
